import { SensitiveDataResponse } from "apis/sensitiveData";
import { Tag } from "components/DesignSystem/Tag/Tag";

export const SensitiveDataItemCell = ({
  record,
}: {
  record: SensitiveDataResponse;
}) => {
  const { sensitive_data_type, name, country_state } = record;

  return (
    <div className="t-flex t-flex-col t-gap-0.5">
      <span className="t-flex t-items-center t-gap-1.5 t-text-body t-text-text-60">
        {sensitive_data_type}
        {country_state && (
          <Tag tagType="purple" size="small" icon={false} rounded>
            {country_state}
          </Tag>
        )}
      </span>
      {Boolean(name) && (
        <span className="t-text-body-sm t-font-light t-text-text-30">
          {name}
        </span>
      )}
    </div>
  );
};
